import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import Login from './pages/Login';
import OTPSetup from './pages/OTPSetup';
import Dashboard from './pages/Dashboard';
import Vendas from './pages/Vendas';
import NovaVenda from './pages/NovaVenda';
import ConsultaViabilidade from './pages/ConsultaViabilidade';
import FilaTratamento from './pages/FilaTratamento';
import VendasPagamento from './pages/VendasPagamento';
import Usuarios from './pages/Usuarios';
import ConfigApi from './pages/ConfigApi';
import CatalogoPlanos from './pages/CatalogoPlanos';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Rotas públicas */}
          <Route path="/login" element={<Login />} />
          <Route path="/otp/setup" element={<OTPSetup />} />
          
          {/* Rotas protegidas */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/vendas" 
            element={
              <ProtectedRoute>
                <Vendas />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/vendas/consulta-viabilidade" 
            element={
              <ProtectedRoute roles={['admin', 'diretor', 'coordenador', 'supervisor', 'vendedor']}>
                <ConsultaViabilidade />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/vendas/nova" 
            element={
              <ProtectedRoute roles={['admin', 'diretor', 'coordenador', 'supervisor', 'vendedor']}>
                <NovaVenda />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/fila-tratamento" 
            element={
              <ProtectedRoute roles={['admin', 'diretor', 'backoffice', 'supervisor_bko']}>
                <FilaTratamento />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/vendas-pagamento" 
            element={
              <ProtectedRoute roles={['admin', 'diretor']}>
                <VendasPagamento />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/config-api" 
            element={
              <ProtectedRoute roles={['admin']}>
                <ConfigApi />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/usuarios" 
            element={
              <ProtectedRoute roles={['admin', 'diretor']}>
                <Usuarios />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/catalogo-planos" 
            element={
              <ProtectedRoute>
                <CatalogoPlanos />
              </ProtectedRoute>
            } 
          />
          
          {/* Rota padrão */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          
          {/* Rota 404 */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
